<template>
  <div class="require-content">
    <div class="container">
      <div class="header">
        <h1 class="header-title">招生信息汇总</h1>
      </div>

      <!-- 筛选表单 -->
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card>
            <template #header>
              <div class="clearfix">
                <span>招生信息汇总</span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="resetFilters"
                >
                  重置条件
                </el-button>
              </div>
            </template>
            <div class="filter-container">
              <el-tabs v-model="filterForm.queryType" class="demo-tabs">
                <el-tab-pane label="按院校查询" name="school">
                  <el-form
                    :inline="true"
                    :model="filterForm"
                    class="demo-form-inline"
                  >
                    <el-form-item label="院校归属">
                      <el-select
                        v-model="filterForm.province"
                        placeholder="请选择省份"
                        class="wider-input"
                      >
                        <el-option
                          v-for="item in provinces"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="院校类型">
                      <el-select
                        v-model="filterForm.schoolType"
                        placeholder="请选择院校类型"
                        class="larger-select"
                      >
                        <el-option
                          v-for="item in schoolTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="招生性别">
                      <el-select
                        v-model="filterForm.gender"
                        placeholder="请选择招生性别"
                        class="wider-input"
                      >
                        <el-option
                          v-for="item in genders"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="search">查询</el-button>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
                <el-tab-pane label="按年份查询" name="examPlace">
                  <el-form
                    :inline="true"
                    :model="filterForm"
                    class="demo-form-inline"
                  >
                    <el-form-item label="年份">
                      <el-select
                        v-model="filterForm.year"
                        placeholder="请选择年份"
                        class="wider-input"
                      >
                        <el-option
                          v-for="item in years"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="search">查询</el-button>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>

              <div class="selected-filters" v-if="hasSelectedFilters">
                <span class="filter-label">已选条件：</span>
                <span
                  class="filter-item"
                  v-for="(value, key) in selectedFilters"
                  :key="key"
                >
                  {{ filterLabels[key] }}: {{ value }}
                  <el-button type="text" size="mini" @click="removeFilter(key)"
                    >×</el-button
                  >
                </span>
              </div>

              <div
                v-if="
                  filterForm.queryType === 'school' &&
                  filteredSchools.length > 0
                "
                class="school-list"
              >
                <div
                  v-for="school in filteredSchools"
                  :key="school.id"
                  class="school-card"
                >
                  <div class="school-logo">
                    <img :src="school.logo" alt="正在加载中......" />
                  </div>
                  <div class="school-name">{{ school.name }}</div>
                  <div class="school-info">
                    <div class="info-item">
                      <span class="info-label">所在省份:</span>
                      <span class="info-value">{{ school.province }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">院校类型:</span>
                      <span class="info-value">{{ school.schoolType }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">招生性别:</span>
                      <span class="info-value">{{ school.gender }}</span>
                    </div>
                  </div>
                  <div class="btn-container">
                    <el-button type="primary" @click="viewDetails(school.id)"
                      >查看详情</el-button
                    >
                  </div>
                </div>
              </div>

              <div
                v-else-if="filterForm.queryType === 'school'"
                class="no-results"
              >
                未查询出匹配院校
              </div>

              <div
                v-if="
                  filterForm.queryType === 'examPlace' &&
                  admissionInfos.length > 0
                "
                class="admission-thumbnails"
              >
                <div
                  v-for="(info, index) in filteredAdmissionInfos"
                  :key="index"
                  class="thumbnail-item"
                >
                  <el-image
                    :src="info.thumbnail"
                    :preview-src-list="[info.thumbnail]"
                    fit="cover"
                    class="thumbnail"
                  >
                    <template #placeholder>
                      <div class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                    </template>
                  </el-image>
                  <div class="thumbnail-info">{{ info.description }}</div>
                </div>
              </div>

              <div
                v-else-if="filterForm.queryType === 'examPlace'"
                class="no-admission-info"
              >
                暂无符合条件的招生信息
              </div>

              <!-- 招生信息分页 -->
              <div
                class="pagination-container"
                v-if="filterForm.queryType === 'examPlace' && examTotal > 0"
              >
                <el-pagination
                  @size-change="handleExamSizeChange"
                  @current-change="handleExamCurrentChange"
                  :current-page="examPage"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="examPageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="examTotal"
                >
                </el-pagination>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <div
        class="pagination-container"
        v-if="filteredSchools.length > 0 && filterForm.queryType === 'school'"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="schools.length"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from "vue";
import { getSchools, getEnrolmentPlans } from "@/api/schoolApi";
import { baseURL } from "@/api/axiosConfig";
import router from "@/router";
import { ElMessage } from "element-plus";

const schools = ref([]);
const loading = ref(true);

// 招生信息分页
const admissionInfos = ref([]);
const examTotal = ref(0);
const examPage = ref(1);
const examPageSize = ref(30);

onMounted(async () => {
  try {
    const [schoolsRes, plansRes] = await Promise.all([
      getSchools(),
      getEnrolmentPlans({ pageNum: 1, pageSize: 30 }),
    ]);

    // 处理院校信息
    if (schoolsRes.data.code === 200) {
      schools.value = schoolsRes.data.data.map((item) => ({
        id: item.id,
        name: item.name,
        province: item.address,
        schoolType: item.type,
        enrollmentType: item.disciplineLevel,
        gender: item.nature,
        logo: baseURL + item.logo,
      }));
    } else {
      ElMessage.error("获取院校信息失败：" + schoolsRes.data.msg);
    }

    // 处理招生计划信息
    if (plansRes.data.code === 200) {
      examTotal.value = plansRes.data.data.total;
      admissionInfos.value = plansRes.data.data.list.map((item) => ({
        id: item.id,
        thumbnail: baseURL + item.imgurl,
        description: item.provincename,
        province: item.provincename,
        year: item.year,
      }));
    } else {
      ElMessage.error("获取招生计划信息失败：" + plansRes.data.msg);
    }
  } catch (error) {
    ElMessage.error("网络错误，请重试");
    console.error(error);
  } finally {
    loading.value = false;
  }
});

const filterForm = reactive({
  queryType: "school",
  province: "",
  schoolType: "",
  gender: "",
  examPlaceProvince: "",
  year: "",
});

const provinces = ref([
  { value: "湖南省", label: "湖南省" },
  { value: "江苏省", label: "江苏省" },
  { value: "湖北省", label: "湖北省" },
  { value: "上海市", label: "上海市" },
  { value: "陕西省", label: "陕西省" },
  { value: "四川省", label: "四川省" },
  { value: "吉林省", label: "吉林省" },
  { value: "重庆市", label: "重庆市" },
  // { value: "浙江省", label: "浙江省" },
  { value: "辽宁省", label: "辽宁省" },
  { value: "北京市", label: "北京市" },
  { value: "山东省", label: "山东省" },
  { value: "安徽省", label: "安徽省" },
  // { value: "广西省", label: "广西省" },
  { value: "江西省", label: "江西省" },
  // { value: "天津市", label: "天津市" },
  { value: "河南省", label: "河南省" },
  // { value: "福建省", label: "福建省" },
  // { value: "甘肃省", label: "甘肃省" },
  // { value: "广东省", label: "广东省" },
  // { value: "海南省", label: "海南省" },
  // { value: "河北省", label: "河北省" },
  // { value: "黑龙江省", label: "黑龙江省" },
  // { value: "内蒙古自治区", label: "内蒙古自治区" },
  // { value: "宁夏回族自治区", label: "宁夏回族自治区" },
  // { value: "青海省", label: "青海省" },
  // { value: "山西省", label: "山西省" },
  // { value: "西藏自治区", label: "西藏自治区" },
  // { value: "新疆维吾尔自治区", label: "新疆维吾尔自治区" },
  // { value: "云南省", label: "云南省" },
]);

const years = ref([
  { value: "2025", label: "2025年" },
  { value: "2026", label: "2026年" },
]);

const schoolTypes = ref([
  { value: "中央军委直属院校", label: "中央军委直属院校" },
  { value: "陆军院校", label: "陆军院校" },
  { value: "海军院校", label: "海军院校" },
  { value: "空军院校", label: "空军院校" },
  { value: "武警院校", label: "武警院校" },
  { value: "火箭军院校", label: "火箭军院校" },
  { value: "联勤保障部队院校", label: "联勤保障部队院校" },
  { value: "网络空间部队院校", label: "网络空间部队院校" },
  { value: "信息支援部队院校", label: "信息支援部队院校" },
  { value: "军事航天部队院校", label: "军事航天部队院校" },
]);

const genders = ref([
  { value: "不限", label: "不限" },
  { value: "男", label: "男" },
  { value: "女", label: "女" },
]);

const filterLabels = {
  province: "省份",
  schoolType: "院校类型",
  gender: "招生性别",
  year: "年份",
};

const filteredAdmissionInfos = computed(() => {
  let result = admissionInfos.value;

  // 按年份筛选
  if (filterForm.year) {
    result = result.filter((info) => info.year === filterForm.year);
  }

  return result;
});

const selectedFilters = computed(() => {
  const filters = {
    province: filterForm.province || null,
    schoolType: filterForm.schoolType || null,
    gender: filterForm.gender || null,
    examPlaceProvince: filterForm.examPlaceProvince || null,
  };
  return Object.keys(filters).reduce((acc, key) => {
    const value = filters[key];
    if (
      value &&
      value !== "请选择省份" &&
      value !== "请选择院校类型" &&
      value !== "请选择招生性别"
    ) {
      acc[key] = value;
    }
    return acc;
  }, {});
});

const hasSelectedFilters = computed(
  () => Object.values(selectedFilters.value).length > 0,
);

const removeFilter = (key) => {
  filterForm[key] = "";
  currentPage.value = 1;
};

const resetFilters = () => {
  Object.keys(filterForm).forEach((key) => (filterForm[key] = ""));
  currentPage.value = 1;
};

const currentPage = ref(1);
const pageSize = ref(9);

const filteredSchools = computed(() => {
  let result = schools.value;

  if (filterForm.queryType === "school") {
    if (filterForm.province) {
      result = result.filter(
        (school) => school.province === filterForm.province,
      );
    }
    if (filterForm.schoolType) {
      result = result.filter(
        (school) => school.schoolType === filterForm.schoolType,
      );
    }
    if (filterForm.gender) {
      result = result.filter((school) => school.gender === filterForm.gender);
    }
  }

  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return result.slice(start, end);
});

const search = async () => {
  currentPage.value = 1;
  examPage.value = 1;

  // 如果是招生信息查询，重新调用接口
  if (filterForm.queryType === "examPlace") {
    await loadEnrolmentPlans();
  }
};

// 加载招生计划数据
const loadEnrolmentPlans = async () => {
  try {
    const plansRes = await getEnrolmentPlans({
      pageNum: examPage.value,
      pageSize: examPageSize.value,
    });

    if (plansRes.data.code === 200) {
      examTotal.value = plansRes.data.data.total;
      admissionInfos.value = plansRes.data.data.list.map((item) => ({
        id: item.id,
        thumbnail: baseURL + item.imgurl,
        description: item.provincename,
        province: item.provincename,
        year: item.year,
      }));
    } else {
      ElMessage.error("获取招生计划信息失败：" + plansRes.data.msg);
    }
  } catch (error) {
    ElMessage.error("网络错误，请重试");
    console.error(error);
  }
};

const viewDetails = (schoolId) => {
  router.push({
    name: "Student",
    params: { id: schoolId },
    query: {
      page: currentPage.value,
      province: filterForm.province,
      schoolType: filterForm.schoolType,
      gender: filterForm.gender,
      examPlaceProvince: filterForm.examPlaceProvince,
    },
  });
};

const handleSizeChange = (newSize) => {
  pageSize.value = newSize;
};

const handleCurrentChange = (newPage) => {
  currentPage.value = newPage;
};

// 招生信息分页处理
const handleExamSizeChange = (newSize) => {
  examPageSize.value = newSize;
  examPage.value = 1;
  loadEnrolmentPlans();
};

const handleExamCurrentChange = (newPage) => {
  examPage.value = newPage;
  loadEnrolmentPlans();
};
</script>

<style scoped>
.require-content {
  padding: 0;
}

.container {
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  margin-top: -20px;
  padding: 4px 10px;
  border-bottom: 1px solid #e5e6eb;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.update-time {
  font-size: 13px;
  color: #64748b;
}

.selected-filters {
  margin-top: 4px;
  padding: 4px 8px;
  background: #f8fafc;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.filter-item {
  display: inline-block;
  margin-right: 4px;
  margin-bottom: 2px;
  padding: 2px 6px;
  background-color: #eff6ff;
  border-radius: 3px;
  font-size: 11px;
  color: #3b82f6;
}

.filter-label {
  font-weight: 500;
  margin-right: 4px;
  color: #64748b;
  font-size: 12px;
}

.school-list {
  margin-top: 4px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 8px;
  padding: 0 8px;
}

.school-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 10px;
  border: 1px solid #e2e8f0;
}

.school-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.08);
  border-color: #dbeafe;
}

.school-name {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #1e293b;
}

.school-info {
  margin-bottom: 4px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  color: #64748b;
  font-size: 12px;
}

.info-label {
  width: 65px;
  font-weight: 500;
  color: #94a3b8;
  font-size: 11px;
}

.info-value {
  flex: 1;
}

.btn-container {
  display: flex;
  justify-content: center;
  margin-top: 6px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 6px;
  margin-bottom: 8px;
}

.school-logo {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  background-color: #f8fafc;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.school-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.no-results {
  text-align: center;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 8px;
  padding: 8px;
}

.wider-input {
  width: 120px;
}

.larger-select {
  width: 140px;
}

.el-select-dropdown__item {
  height: 24px;
  line-height: 24px;
}

.el-select-dropdown__item.selected {
  height: 28px;
  line-height: 28px;
}

.demo-tabs {
  margin-bottom: 16px;
  padding: 4px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.demo-tabs >>> .el-tabs__nav {
  display: flex;
  justify-content: flex-start;
  gap: 4px;
}

.demo-tabs >>> .el-tabs__nav-scroll {
  padding: 0;
}

.demo-tabs >>> .el-tabs__item {
  font-size: 14px;
  font-weight: 500;
  padding: 11px 24px;
  margin: 0;
  border-radius: 10px;
  background: transparent;
  transition: all 0.2s ease;
  color: #64748b;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  line-height: 1;
}

.demo-tabs >>> .el-tabs__item:hover {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.06);
}

.demo-tabs >>> .el-tabs__item.is-active {
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3),
    0 1px 3px rgba(59, 130, 246, 0.2);
}

.demo-tabs >>> .el-tabs__item.is-active::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 4px;
  background: linear-gradient(90deg, #10b981 0%, #3b82f6 100%);
  border-radius: 2px;
}

.demo-tabs >>> .el-tabs__active-bar {
  display: none;
}

.admission-thumbnails {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
  margin-top: 4px;
  padding: 0 8px;
}

.thumbnail-item {
  margin-right: 0;
  margin-bottom: 0;
}

.thumbnail {
  width: 100%;
  height: 85px;
  cursor: pointer;
  border-radius: 4px;
}

.thumbnail-info {
  margin-top: 3px;
  text-align: center;
  font-size: 12px;
  color: #475569;
}

.no-admission-info {
  text-align: center;
  margin-top: 6px;
  padding: 8px;
  color: #94a3b8;
}
</style>
